/**
 * Theme Block Menu JavaScript
 * Sadece mobil menü için gerekli - Desktop'ta CSS hover ile çalışıyor
 */

(function() {
  'use strict';

  // Mobil menü toggle (tıklama ile açma/kapama)
  function setupMobileMenu() {
    const menuItems = document.querySelectorAll('.nav-item--block');
    
    menuItems.forEach(item => {
      const link = item.querySelector('.menu-main-category__link');
      
      if (link) {
        link.addEventListener('click', (e) => {
          // Sadece mobilde menüyü toggle yap
          if (window.innerWidth <= 1330) {
            e.preventDefault();
            
            // Diğer açık menüleri kapat
            menuItems.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('mobile-open');
              }
            });
            
            // Bu menüyü aç/kapat
            item.classList.toggle('mobile-open');
          }
        });
      }
    });
  }

  // Mobil close button ekle
  function addCloseButtons() {
    const dropdowns = document.querySelectorAll('.menu-dropdown');
    
    dropdowns.forEach(dropdown => {
      if (!dropdown.querySelector('.menu-dropdown__close')) {
        const closeButton = document.createElement('button');
        closeButton.className = 'menu-dropdown__close';
        closeButton.setAttribute('aria-label', 'Menüyü Kapat');
        closeButton.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          const navItem = dropdown.closest('.nav-item--block');
          if (navItem) {
            navItem.classList.remove('mobile-open');
          }
        });
        
        dropdown.insertBefore(closeButton, dropdown.firstChild);
      }
    });
  }

  // Dışarı tıklandığında menüyü kapat
  function setupClickOutside() {
    document.addEventListener('click', (e) => {
      const menuItems = document.querySelectorAll('.nav-item--block');
      
      menuItems.forEach(item => {
        if (!item.contains(e.target)) {
          item.classList.remove('mobile-open');
        }
      });
    });
  }

  // Initialize
  function init() {
    addCloseButtons();
    setupMobileMenu();
    setupClickOutside();
  }

  // DOM hazır olduğunda çalıştır
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor'da section yüklendiğinde yeniden başlat
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();

